module.exports = __webpack_public_path__ + "static/media/defaultPic0.24d33b73.png";